import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TaskManagementPanel = ({ candidate, onClose }) => {
  const [tasks, setTasks] = useState([
    {
      id: 1,
      title: 'Send Welcome Email',
      description: 'Automated welcome email with company information',
      assignedTo: 'HR Coordinator',
      status: 'completed',
      dueDate: '2026-01-18',
      priority: 'high'
    },
    {
      id: 2,
      title: 'Equipment Provisioning',
      description: 'Laptop, phone, and office supplies',
      assignedTo: 'IT Support',
      status: 'in-progress',
      dueDate: '2026-01-22',
      priority: 'high'
    },
    {
      id: 3,
      title: 'System Access Setup',
      description: 'Email, HRIS, and compliance portal access',
      assignedTo: 'IT Support',
      status: 'pending',
      dueDate: '2026-01-22',
      priority: 'high'
    },
    {
      id: 4,
      title: 'NASFUND Registration',
      description: 'Complete NASFUND member registration forms',
      assignedTo: 'HR Coordinator',
      status: 'pending',
      dueDate: '2026-01-25',
      priority: 'medium'
    },
    {
      id: 5,
      title: 'PNG Employment Act Compliance',
      description: 'Verify employment contract compliance',
      assignedTo: 'Compliance Officer',
      status: 'pending',
      dueDate: '2026-01-25',
      priority: 'high'
    }
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'in-progress':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'pending':
        return 'bg-gray-100 text-gray-700 border-gray-200';
      case 'overdue':
        return 'bg-red-100 text-red-700 border-red-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-red-600';
      case 'medium':
        return 'text-amber-600';
      case 'low':
        return 'text-gray-600';
      default:
        return 'text-gray-600';
    }
  };

  const handleTaskStatusChange = (taskId, newStatus) => {
    setTasks(prev =>
      prev?.map(task =>
        task?.id === taskId ? { ...task, status: newStatus } : task
      )
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="bg-emerald-100 p-2 rounded-lg">
            <Icon name="CheckSquare" size={24} className="text-emerald-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Task Management</h2>
            <p className="text-sm text-gray-600">{candidate?.employeeName}</p>
          </div>
        </div>
        <Button onClick={onClose} variant="outline" size="sm">
          <Icon name="X" size={16} className="mr-1" />
          Close
        </Button>
      </div>

      {/* Task List */}
      <div className="space-y-3">
        {tasks?.map(task => (
          <div key={task?.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-base font-semibold text-gray-900">{task?.title}</h3>
                  <Icon
                    name="AlertCircle"
                    size={16}
                    className={getPriorityColor(task?.priority)}
                  />
                </div>
                <p className="text-sm text-gray-600 mb-2">{task?.description}</p>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    {task?.assignedTo}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    Due: {new Date(task?.dueDate)?.toLocaleDateString()}
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(
                    task?.status
                  )}`}
                >
                  {task?.status?.replace('-', ' ')?.toUpperCase()}
                </span>
                {task?.status !== 'completed' && (
                  <Button
                    onClick={() => handleTaskStatusChange(task?.id, 'completed')}
                    size="sm"
                    className="bg-emerald-600 text-white"
                  >
                    <Icon name="Check" size={14} className="mr-1" />
                    Complete
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskManagementPanel;